import React, { forwardRef } from 'react';

export const MacroRecordsHeader = ({
  selectAllLabel = '选择所有',
  onSelectAll,
  onDelete,
  deleteDisabled = false,
}) => (
  <div className="macro-records-header">
    <div className="section-title">宏记录</div>
    <div className="macro-records-actions">
      <button type="button" className="action-btn" onClick={onSelectAll}>
        {selectAllLabel}
      </button>
      <button
        type="button"
        className="action-btn"
        onClick={onDelete}
        disabled={deleteDisabled}
      >
        删除
      </button>
    </div>
  </div>
);

export const MacroRecordsList = forwardRef(
  ({ className = '', children, ...props }, ref) => (
    <div
      ref={ref}
      className={`macro-records-list ${className}`.trim()}
      {...props}
    >
      {children}
    </div>
  )
);

MacroRecordsList.displayName = 'MacroRecordsList';
